<script type="text/babel">
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'

export default {
    mixins: [RestoreOnPageBack],
    props: ['brand'],

    data() {
        return {
            industries: window.Spark.industries,
            form: new SparkForm({
                name: this.brand.name,
                website: this.brand.website,
                logo_url: this.brand.logo_url,
                //industry: this.brand.industry,
            }),
            addressForm: new SparkForm({
                ...this.brand,
                billing_country: this.brand.billing_country == null ? 'default' : this.brand.billing_country,
            }),
            vatForm: new SparkForm(this.brand),
        }
    },

    methods: {
        update() {
            Spark.sendFormData('put', route('api.brand.update', this.brand.id), this.form).then(
                response => {
                    Bus.$emit('currentTeamUpdated', response.data)
                    this.form.logo_url = response.data.logo_url
                }
            )
        },

        updateAddress() {
            Spark.put(route('api.brand.address.update', this.brand.id), this.addressForm).then(
                response => {
                    Bus.$emit('currentTeamUpdated', response.data)
                    Object.assign(this.addressForm, response.data)
                }
            )
        },

        updateVatId() {
            Spark.put(route('api.brand.vat_id.update', this.brand.id), this.vatForm).then(
                response => {
                    Bus.$emit('currentTeamUpdated', response.data)
                    Object.assign(this.vatForm, response.data)
                }
            )
        },
    },
}
</script>
